import Vue from 'vue';

import _each from "lodash/each";
import _toLower from "lodash/toLower";
import _includes from "lodash/includes";
import _filter from "lodash/filter";
import _uniqBy from "lodash/uniqBy";

export default {
  getWords: ({state, commit}) => {
    return new Promise((resolve, reject) => {
      if (state.words[0]) {
        resolve(state.words)
      } else {
        Vue.http.get('/static/data/words.json').then(res => {
          commit('words', res.body)
          resolve(res.body)
        });
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/words.js